var exports = {
  "kL": "xa15a2ab7--46fe72--container",
  "Y3": "xa15a2ab7--46fe72--buttons-container",
  "x6": "xa15a2ab7--46fe72--button",
};

module.exports = exports;
